// endWorkout.js

import { getWorkoutStreak, markWorkoutAsCompleted } from './cookies.js';
import { getSuccessMessage, getStreakSymbols, generateSocialMediaPost } from './messageGenerator.js';
import { activateShareButton, playSuccessSound, toggleView } from './ui.js';

/*!
 * Canvas Confetti v1.0.0
 * https://www.kirilv.com/canvas-confetti/
 * Licensed under the MIT License.
 * Copyright (c) 2018 Kiril Vatev
 */

// Function to trigger confetti animation
export function triggerConfetti() {
    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.zIndex = '5';
    document.body.appendChild(canvas);

    const confetti = window.confetti.create(canvas, {
        resize: true,
        useWorker: true
    });

    confetti({
        particleCount: 200,
        spread: 160,
        origin: { y: 0.6 }
    });
}

export function onWorkoutComplete() {
    // Set Cookies
    markWorkoutAsCompleted();

    triggerConfetti();
    playSuccessSound();
    showSuccessView();
}

const STREAK_LEGEND_TEXT = "💪 = 1 day | 🏅 = 10 days | 🏆 = 50 days | 💯 = 100 days | 🚀 = 365 days";

export function showSuccessView() {
    const currentStreak = getWorkoutStreak();
    const successMessageValue = getSuccessMessage(currentStreak);
    const socialMediaPost = generateSocialMediaPost(currentStreak);
    const streakSymbols = getStreakSymbols(currentStreak);

    const successMessageElement = document.getElementById('success-message');
    const streakSymbolsElement = document.getElementById('streak-symbols');
    const streakLegendElement = document.getElementById('streak-legend');

    // Update text content
    successMessageElement.textContent = successMessageValue;
    streakSymbolsElement.textContent = streakSymbols;
    streakLegendElement.textContent = STREAK_LEGEND_TEXT;

    // Toggle the view and activate share button
    toggleView("success-container");
    activateShareButton(socialMediaPost);
}